import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import {
  ISIVReportClinicalTrialData,
  ISIVReportInformedConsentVerification,
  ISIVReportSiteAdequacy
} from 'src/types/SIVReport';
import ClinicalTrialDetails from './ClinicalTrialDetails';
import InformedConsentVerification from './InformedConsent';
import SiteAdequacy from './SiteAdequacy';
import './SivReport.scss';
import {
  ISIVReportMandatory,
  ISIVReportModifiedKeys,
  ISIVReportModifiedKeysOfKeys,
  ISIVReportStep1Accordions,
  MandatoryData
} from './useSivReport';

export interface ISIVReportPageStep1 {
  getSivReportData: (key: ISIVReportModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  expandedState: ISIVReportStep1Accordions;
  toggle: (key: keyof ISIVReportStep1Accordions, expanded: boolean) => void;
  clinicalTrialData: ISIVReportClinicalTrialData;
  updateClinicalData: (data: ISIVReportClinicalTrialData) => void;
  isUpdate: boolean;
  setIsUpdate: (isUpdate: boolean) => void;
  siteAdequacyData: ISIVReportSiteAdequacy;
  updateSiteAdequacyData: (data: ISIVReportSiteAdequacy) => void;
  informedConsentVerificationData: ISIVReportInformedConsentVerification;
  updateIinformedConsentVerification: (data: ISIVReportInformedConsentVerification) => void;
  Step1: ISIVReportStep1Accordions;
  setIsChange: (step: ISIVReportModifiedKeys, key: ISIVReportModifiedKeysOfKeys, val: boolean) => void;
  updateSIVReportMandatoryData: (key: keyof ISIVReportMandatory, value: MandatoryData) => void;
  mandatory: ISIVReportMandatory;
  sivReportSavedId: string;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const SIVReportPage: React.FunctionComponent<ISIVReportPageStep1> = ({
  getSivReportData,
  saveDisable,
  expandedState,
  toggle,
  clinicalTrialData,
  updateClinicalData,
  isUpdate,
  siteAdequacyData,
  updateSiteAdequacyData,
  informedConsentVerificationData,
  updateIinformedConsentVerification,
  Step1,
  setIsChange,
  updateSIVReportMandatoryData,
  mandatory,
  sivReportSavedId,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  return (
    <div className="pi-accordion siv-accordion">
      <Accordion
        expanded={expandedState.clinicalTrialDetails}
        onChange={(_, expanded) => {
          toggle('clinicalTrialDetails', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography>Clinical Trial Details </Typography>
        </AccordionSummary>

        <ClinicalTrialDetails
          getSivReportData={getSivReportData}
          saveDisable={saveDisable}
          isChange={Step1.clinicalTrialDetails}
          clinicalTrialData={clinicalTrialData}
          updateClinicalData={updateClinicalData}
          isUpdate={isUpdate}
          setIsChange={setIsChange}
          updateSIVReportMandatoryData={updateSIVReportMandatoryData}
          mandatory={mandatory.clinicalTrialDetails}
          sivReportSavedId={sivReportSavedId}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.siteAdequacy}
        onChange={(_, expanded) => {
          toggle('siteAdequacy', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Site Adequacy </Typography>
        </AccordionSummary>
        <SiteAdequacy
          getSivReportData={getSivReportData}
          saveDisable={saveDisable}
          isUpdate={isUpdate}
          siteAdequacyData={siteAdequacyData}
          isChange={Step1.siteAdequacy}
          updateSiteAdequacyData={updateSiteAdequacyData}
          setIsChange={setIsChange}
          updateSIVReportMandatoryData={updateSIVReportMandatoryData}
          mandatory={mandatory.siteAdequacy}
          sivReportSavedId={sivReportSavedId}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.informedConsentVerification}
        onChange={(_, expanded) => {
          toggle('informedConsentVerification', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel3bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Informed Consent </Typography>
        </AccordionSummary>
        <InformedConsentVerification
          getSivReportData={getSivReportData}
          saveDisable={saveDisable}
          informedConsentVerificationData={informedConsentVerificationData}
          isUpdate={isUpdate}
          updateIinformedConsentVerification={updateIinformedConsentVerification}
          isChange={Step1.informedConsentVerification}
          setIsChange={setIsChange}
          updateSIVReportMandatoryData={updateSIVReportMandatoryData}
          mandatory={mandatory.informedConsentVerification}
          sivReportSavedId={sivReportSavedId}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>
    </div>
  );
};

export default SIVReportPage;
